// What players see about a map before loading it: its timeruns and ETJump
// worldspawn rules (from the BSP entity lump). Used by the server catalog and
// the client's map browser.

import { entityNum, parseEntities } from './entities';
import { timerunNames } from './game/mapLogic';

export interface MapRulesInfo {
  noJumpDelay: boolean;
  /** 0 off, 1 no fall damage, 2 no fall damage and no knockback. */
  noFallDamage: number;
  noOverbounce: boolean;
  noWallbug: boolean;
}

export interface MapMeta {
  runs: string[];
  rules: MapRulesInfo;
  /** worldspawn "message" (map title), may contain colour codes. */
  message?: string;
}

/** Map info from the entity string of its BSP. */
export function mapMetaFromEntities(entityString: string): MapMeta {
  const entities = parseEntities(entityString);
  const ws = entities.find((e) => e.classname === 'worldspawn') ?? {};
  return {
    runs: timerunNames(entities),
    rules: {
      noJumpDelay: entityNum(ws, 'nojumpdelay') !== 0,
      noFallDamage: Math.max(0, Math.min(2, entityNum(ws, 'nofalldamage'))),
      noOverbounce: entityNum(ws, 'nooverbounce') !== 0,
      noWallbug: entityNum(ws, 'nowallbug') !== 0,
    },
    message: ws.message || undefined,
  };
}

/** Short descriptions of the non-default rules, for tips and the details panel. */
export function describeRules(rules: MapRulesInfo): string[] {
  const out: string[] = [];
  if (rules.noJumpDelay) out.push('No jump delay');
  if (rules.noFallDamage === 1) out.push('No fall damage');
  if (rules.noFallDamage === 2) out.push('No fall damage, no landing knockback');
  if (rules.noOverbounce) out.push('No overbounce');
  if (rules.noWallbug) out.push('No wallbug');
  return out;
}
